import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ModelNotification\CreateModelNotificationV2Controller::__invoke
* @see app/Http/Controllers/ModelNotification/CreateModelNotificationV2Controller.php
* @route '/api/model-notification/v2'
*/
const CreateModelNotificationV2Controller = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateModelNotificationV2Controller.url(options),
    method: 'post',
})

CreateModelNotificationV2Controller.definition = {
    methods: ["post"],
    url: '/api/model-notification/v2',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ModelNotification\CreateModelNotificationV2Controller::__invoke
* @see app/Http/Controllers/ModelNotification/CreateModelNotificationV2Controller.php
* @route '/api/model-notification/v2'
*/
CreateModelNotificationV2Controller.url = (options?: RouteQueryOptions) => {
    return CreateModelNotificationV2Controller.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ModelNotification\CreateModelNotificationV2Controller::__invoke
* @see app/Http/Controllers/ModelNotification/CreateModelNotificationV2Controller.php
* @route '/api/model-notification/v2'
*/
CreateModelNotificationV2Controller.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateModelNotificationV2Controller.url(options),
    method: 'post',
})

export default CreateModelNotificationV2Controller